import { render, staticRenderFns } from "./PromoBoxSundairApp.vue?vue&type=template&id=2191d7ed&scoped=true"
import script from "./PromoBoxSundairApp.vue?vue&type=script&lang=js"
export * from "./PromoBoxSundairApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191d7ed",
  null
  
)

export default component.exports